import Router from 'next/router';
import { useContext, useEffect } from 'react';
import paramsToRemove from '~/constants/paramsToRemove';
import SearchContext from '~/contexts/SearchContext';

export default function useRemoveQueryParams() {
  const { showFinance } = useContext(SearchContext);

  useEffect(() => {
    let { query } = Router;

    paramsToRemove.forEach(param => {
      if (query[param]) {
        const { [param]: ignoredParam, ...rest } = query;
        query = rest;
      }
    });

    void Router.push(
      {
        pathname: Router.pathname,
        query
      },
      undefined,
      { shallow: true, scroll: false }
    );
  }, [showFinance]);
}
